const MIME_BY_EXTENSION: Record<string, string> = {
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  webm: 'video/webm',
  avi: 'video/x-msvideo',
  wmv: 'video/x-ms-wmv',
  flv: 'video/x-flv',
  m4v: 'video/x-m4v',
  mkv: 'video/x-matroska',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  bmp: 'image/bmp',
  ico: 'image/x-icon',
  pdf: 'application/pdf',
};

export function extensionFromFileName(fileName: string): string | null {
  const lastDot = fileName.lastIndexOf('.');
  if (lastDot <= 0 || lastDot === fileName.length - 1) return null;
  return fileName.slice(lastDot + 1).toLowerCase();
}

export function guessMimeTypeFromFileName(fileName: string): string {
  const ext = extensionFromFileName(fileName);
  if (ext && MIME_BY_EXTENSION[ext]) return MIME_BY_EXTENSION[ext];
  return 'application/octet-stream';
}

/** Prefer a concrete blob type; fall back to file-name extension when generic. */
export function resolveMimeType(fileName: string, blobType?: string | null): string {
  const normalized = (blobType || '').trim().toLowerCase();
  if (normalized && normalized !== 'application/octet-stream') return normalized;
  return guessMimeTypeFromFileName(fileName);
}
